function isPointOnSegment(px, py, x1, y1, x2, y2, eps = 1e-10) {
  const cross = (py - y1) * (x2 - x1) - (px - x1) * (y2 - y1);
  if (Math.abs(cross) > eps) return false;
  const dot = (px - x1) * (px - x2) + (py - y1) * (py - y2);
  return dot <= eps;
}

function pointInRing(point, ring) {
  const [px, py] = point;
  let inside = false;

  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i];
    const [xj, yj] = ring[j];

    if (isPointOnSegment(px, py, xi, yi, xj, yj)) {
      return true;
    }

    const intersects =
      (yi > py) !== (yj > py) &&
      px < ((xj - xi) * (py - yi)) / (yj - yi) + xi;
    if (intersects) inside = !inside;
  }

  return inside;
}

function pointInPolygon(point, rings) {
  if (!Array.isArray(rings) || rings.length === 0) return false;
  if (!pointInRing(point, rings[0])) return false;

  // Holes: if point is in a hole, it's outside.
  for (let i = 1; i < rings.length; i += 1) {
    if (pointInRing(point, rings[i])) return false;
  }
  return true;
}

export function findAb604District(lon, lat, geojson) {
  if (!Number.isFinite(lon) || !Number.isFinite(lat)) return null;
  const features = geojson?.features;
  if (!Array.isArray(features)) return null;

  const point = [lon, lat];

  for (const feature of features) {
    const district = feature?.properties?.DISTRICT;
    const geometry = feature?.geometry;
    if (!geometry?.type || !geometry?.coordinates) continue;

    if (geometry.type === 'Polygon') {
      if (pointInPolygon(point, geometry.coordinates)) {
        return district != null ? String(district) : null;
      }
      continue;
    }

    if (geometry.type === 'MultiPolygon') {
      for (const polygon of geometry.coordinates) {
        if (pointInPolygon(point, polygon)) {
          return district != null ? String(district) : null;
        }
      }
    }
  }

  return null;
}
